import React, { FC, useState } from 'react';

import { Text } from '@sitecore-jss/sitecore-jss-react';
import { BreakpointsInPx } from '../../../../constants/breakpoints.constants';
import { iconSize } from '../../../../constants/icon.constants';
import useMediaQuery from '../../../../hooks/useMediaQuery';
import Icon from '../../../@shared/icon';
import Picture from '../../../@shared/picture';
import { TRegionSelector, TSplashComponentRegion } from '../../types/splashComponent.types';
import MarketSelector from '../marketSelector';
import './styles.scss';


const RegionSelector: FC<TRegionSelector> = ({ model }) => {
    const [selectedRegion, setSelectedRegion] = useState<TSplashComponentRegion | null>();
    const isTablet = useMediaQuery(`(min-width: ${BreakpointsInPx['tbl-l']})`, true);
    const MARKET_LIST_COLUMNS_PER_ROW = 3;
    const regionRowCount = Math.ceil(model.regions.length / MARKET_LIST_COLUMNS_PER_ROW);
    const regionsByRowArray = Array.from({ length: regionRowCount }, (_e, ind) => model.regions.slice(3 * ind, 3 * (ind + 1))); // Array of array of 3 markets data

    const handleRegionSelection = (region: TSplashComponentRegion) => {
        if (selectedRegion?.id === region.id) {
            setSelectedRegion(null);
            return;
        }

        setSelectedRegion(region);
    };

    return (
        <div className='region-selector'>
            <Text field={model.title} tag="div" className="region-selector__title" />
            {regionsByRowArray.map((eachRegionSet) => (
                <>
                    {isTablet && (
                        <div className='region-selector-continent-row__container'>
                            <div className='region-selector-continent-row'>
                                {eachRegionSet?.map(region => (
                                    <div className='region-selector-continent' key={region.id}>
                                        <Picture
                                            editorialImageProps={{
                                                mobileImage: region.fields.regionSelectionImage,
                                                mobileTransformation: 'Size200',
                                                cssClassImageEl: 'region-selector-continent__flag',
                                                cssClassPictureEl: 'region-selector-continent__flag-wrapper'
                                            }}
                                        />
                                        <Text tag='p' field={region.fields.title} className='region-selector-continent__title' />
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}

                    <ul className='region-selector-market-row'>
                        {eachRegionSet?.map((region) => (
                            <li key={region.id} className={`region-selector-market${selectedRegion?.id === region.id ? ' region-selector-market--active' : ''}`}>
                                {!isTablet && (
                                    <div className={'region-selector-market__heading'} onClick={() => handleRegionSelection(region)}>
                                        <Picture
                                            editorialImageProps={{
                                                mobileImage: region.fields.regionSelectionImage,
                                                mobileTransformation: 'Size200',
                                                cssClassImageEl: 'region-selector-market__flag',
                                                cssClassPictureEl: 'region-selector-market__flag-wrapper'
                                            }}
                                        />
                                        <Text tag='p' field={region.fields.title} className='region-selector-market__title' />
                                        <Icon
                                            iconName={`arrow-chevron-${selectedRegion?.id === region.id ? 'up' : 'down'}`}
                                            size={iconSize['dsk']}
                                            color="primary"
                                            extraClassName='region-selector-market__chevron-icon'
                                        />
                                    </div>
                                )}
                                {(isTablet ? true : selectedRegion?.id === region.id) && <MarketSelector markets={region.fields.markets} />}
                            </li>
                        ))}
                    </ul>
                </>
            ))}
        </div>
    )
};

export default RegionSelector;
